import React from 'react';
import { Container } from 'react-bootstrap';
import EmailLogsTable from './EmailLogsTable';
import './Email.css';

const EmailLogs = () => {
  return (
    <Container fluid className="email-page">
      {/* Header */}
      <div className="email-header">
        <div className="mb-4">
          <h2 className="email-page-title">Email Logs</h2>
          <p className="text-muted mb-0">View and filter email sending history</p>
        </div>
      </div>

      {/* Email Logs Table */}
      <div className="email-logs-section">
        <EmailLogsTable />
      </div>
    </Container>
  );
};

export default EmailLogs;

